import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { UserProvider } from './contexts/userContext';
import { FeedbackProvider } from './contexts/feedbackContext';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY || '');

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Elements stripe={stripePromise}>
    <FeedbackProvider>
      <UserProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </UserProvider>
    </FeedbackProvider>
  </Elements>
);
